import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Truck, CheckCircle, ExternalLink } from 'lucide-react';
import { useFeatures } from '../../contexts/FeatureContext';

export function BecomeRunnerButton({ variant = "default", size = "default", className = "" }) {
  const navigate = useNavigate();
  const { isFeatureEnabled } = useFeatures();
  
  const runnersEnabled = isFeatureEnabled('runners_service');
  
  if (!runnersEnabled) {
    return null; // Hide if runners feature is disabled
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={() => navigate('/pickup/driver/register')}
    >
      <Truck className="h-4 w-4 mr-2" />
      Become a Runner
      <Badge variant="secondary" className="ml-2">Earn Money</Badge>
    </Button>
  );
}

export function RunnerBadge({ isRunner, verified }) {
  if (!isRunner) return null;

  return (
    <Badge variant={verified ? "default" : "secondary"} className="gap-1">
      <Truck className="h-3 w-3" />
      {verified && <CheckCircle className="h-3 w-3" />}
      Runner
    </Badge>
  );
}
